export default "__VITE_ASSET__CkDkPbdo__"